/* NOT SIGNED UP:
bmi
conditions: [
  pregnant
  tryingpregnant
  breastfeeding
  cancer
  diabetesInsulin
  heartConditions
  diabetic
  noneConditions
]
conditions - next: [
  gastrointestinal
  suicidal
  eatingDisorder
  organTransplant
  kidneyDisease
  noneConditionsNext
]
dob
diagnosed: [
  hypothyroidism
  hypothyroidism_diagnosed_date
  type2diabetes
  preDiabetes
  hypertension
  sleepApnea
  cardiovascularDisease
  hyperlipidemia
  noneExperience
]
feet
inches
pounds
assignedsexatbirth
weightLossGoal: (values: 1-15, 16-50, 51+, notSure)
previousGlp1: (values: currentlyTakingGlp1, stoppedGlp1, neverGlp1)
stoppedGlp1: (values: withinLast2weeks, lessThan3months, moreThan3Months)
*/

export const mutationPrep = (data) => {
  let params = [];
  // {
  //   conditions:[],
  //   diagnosed: []
  // }
  // if(data['bmi']){
  //   params['bmi']=data.
  // }

  // params.push({
  //   endpoint: 'obgyn',
  //   questionId: 'LOCAL.83',
  //   answer: data['pregnant'] ? 'Currently pregnant' : data['tryingpregnant'] ? 'Planning to be pregnant' : 'Not pregnant',
  // });
  if (data['hypothyroidism']) {
    params.push({
      endpoint: 'medicalHistory',
      values: [
        {
          answer: 'Y',
          value: `Diagnosed in (Year) - ${data['hypothyroidism'] ? data['hypothyroidism_diagnosed_date'] : 'unknown'}`,
          questionId: '19',
        },
      ],
    });
  }
  if (data['type2diabetes']) {
    params.push({
      endpoint: 'medicalHistory',
      values: [
        {
          questionId: '6',
          answer: 'Y',
          value: 'Type 2',
        },
      ],
    });
  }
  if (data['preDiabetes']) {
    params.push({
      endpoint: 'medicalHistory',
      values: [
        {
          questionId: '6',
          answer: 'Y',
          value: 'Pre diabetes',
        },
      ],
    });
  }

  // TODO check prod id
  params.push({
    endpoint: 'medicalHistory',
    values: [
      {
        questionId: '8',
        answer: data['hypertension'] ? 'Y' : 'N',
      },
    ],
  });
  // TODO check prod id
  params.push({
    endpoint: 'medicalHistory',
    values: [
      {
        questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '470' : '489',
        answer: data['sleepApnea'] ? 'Y' : 'N',
      },
    ],
  });
  // TODO check prod id
  params.push({
    endpoint: 'medicalHistory',
    values: [
      {
        questionId: '7',
        answer: data['hyperlipidemia'] ? 'Y' : 'N',
      },
    ],
  });

  if (data['cardiovascularDisease']) {
    // TODO not existing athena
    // params.push({
    // endpoint: 'medicalHistory',
    //   questionId: window._env_.REACT_APP_GRAPHQL_URL.indexOf('preview') > -1 || window._env_.REACT_APP_GRAPHQL_URL.indexOf('localhost') > -1 ? '470' : '8',
    //   answer: 'Y',
    // });
  }
  if (!!data['feet']) {
    params.push({
      endpoint: 'socialHistory',
      values: [
        {
          questionId: 'LOCAL.121',
          answer: `${data['feet']}'${data['inches'] || 0}"`,
        },
      ],
    });
  }

  if (!!data['pounds']) {
    params.push({
      endpoint: 'socialHistory',
      values: [
        {
          questionId: 'LOCAL.122',
          answer: `${data['pounds']}`,
        },
      ],
    });
  }

  return params
  // if(!!data['weightLossGoal']){
  //   params.push({
  //     questionId: '_vitalsnote',
  //     answer: `Weight Loss Goal: ${data['weightLossGoal']}`,
  //   })}
};
